import cn from 'classnames';
import { SocialNetworks } from '@ui/league/SocialNetworks';
import { Link } from 'react-router';
import { useNavigationsQuery } from '@data/navigations/useNavigationsQuery';
import { useDeviceType } from '@ui/utils/useDeviceType';
import { DeviceType } from '@repo/types';
import { useState } from 'react';
import { Image } from '../../../common/components/Image';

// @ts-ignore
const siteName = import.meta.env.VITE_SITE_NAME;

function Footer() {
  const deviceType = useDeviceType();
  const { data, isLoading, error } = useNavigationsQuery();
  const isMobile = deviceType === DeviceType.mobile;
  const isTablet = deviceType === DeviceType.tablet;

  const [selectedNode, setSelectedNode] = useState<string | null>(null);

  const handleNodeSelection = (newSelectedNode: string) => {
    setSelectedNode(selectedNode === newSelectedNode ? null : newSelectedNode);
  };

  if (isLoading) {
    return null;
  }

  const navigationNodes = isMobile || isTablet ? data?.footer?.mobileNodes : data?.footer?.desktopNodes;

  if (error || !navigationNodes || navigationNodes.length === 0 || !data) {
    return null;
  }

  return (
    <footer className="footer">
      {siteName && <h2 className="footer__title">{siteName}</h2>}
      <div className="footer__nav-container">
        {navigationNodes.map((node) => (
          <nav
            className={cn('footer__nav-section', {
              'footer__nav-section--selected': selectedNode === node.id,
            })}
          >
            {isMobile || isTablet ? (
              <button className="footer__nav-section-header-wrapper" onClick={() => handleNodeSelection(node.id)}>
                <h3 className="footer__nav-section-header">{node.label}</h3>
                <Image
                  className="footer__nav-section-dropdown-arrow"
                  src="arrow-down.svg"
                  width={24}
                  height={24}
                  alt="arrow down"
                />
              </button>
            ) : (
              <h4 className="footer__nav-section-header">{node.label}</h4>
            )}
            <ul className="footer__list">
              {node.children?.map(({ url, label, id }) => (
                <li key={id}>
                  <Link
                    className="footer__link"
                    to={url?.includes('.') && !url.startsWith('http') ? `https://${url}` : (url as string)}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
        <SocialNetworks />
      </div>
      <Link className="footer__copyright" to="https://getleaguehub.com/" target={'_blank'}>
        &#169; Copyright 2024 LeagueHub | All rights reserved.
      </Link>
    </footer>
  );
}

export default Footer;
